import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
  Table,
} from 'reactstrap'
import { api } from '../../utils'

export default function ClientCreationList() {
  const [clienti, setClienti] = useState([])
  const [nomeFilter, setNomeFilter] = useState('')
  const [appliedNomeFilter, setAppliedNomeFilter] = useState('')

  useEffect(() => {
    const fetchClienti = async () => {
      const params = appliedNomeFilter ? { nome: appliedNomeFilter } : {}
      const response = await api.get('clienti/', { params })
      setClienti(Array.isArray(response.data) ? response.data : response.data?.results || [])
    }

    fetchClienti()
  }, [appliedNomeFilter])

  return (
    <div className="header bg-gradient-info pb-8 pt-5 pt-md-8">
      <div className="container-fluid">
        <Row>
          <Col>
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between align-items-center">
                <h3 className="mb-0">Lista Clienti</h3>
                <Link to="/client-creation/create">Crea Cliente</Link>
              </CardHeader>
              <CardBody>
                <Row className="align-items-end mb-3">
                  <Col md={4}>
                    <FormGroup>
                      <Label for="client-creation-filter-name">Nome Cliente</Label>
                      <Input
                        id="client-creation-filter-name"
                        value={nomeFilter}
                        onChange={(event) => setNomeFilter(event.target.value)}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={8} className="text-right pb-3">
                    <Button
                      color="light"
                      className="mr-2"
                      onClick={() => {
                        setNomeFilter('')
                        setAppliedNomeFilter('')
                      }}
                    >
                      Reset
                    </Button>
                    <Button color="primary" onClick={() => setAppliedNomeFilter(nomeFilter)}>
                      Apply
                    </Button>
                  </Col>
                </Row>

                <Table>
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Nome</th>
                    </tr>
                  </thead>
                  <tbody>
                    {clienti.map((cliente) => (
                      <tr key={cliente.id}>
                        <td>{cliente.id}</td>
                        <td>{cliente.nome}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}
